import { Icons } from 'components';

const columns = (currencyText) => [

  {
    title: 'شناسه محصول',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام محصول',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => <CustomTitle rd={rd} />,
  },
  {
    title: `قیمت (${currencyText})`,
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'price',
  },
  {
    title: 'ارائه دهنده محصول',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd.business ? `${rd.business?.name}` : '-'),
  },
];

const generateData = (rows, query) => {
  const newData = rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
  return newData;
};
export const CustomTitle = ({ rd }) => {
  return (
    <div style={{ display: 'flex' }}>
      {rd.templateCode == 'service_call' ? (
        <Icons icon="Setting" color="#696969ff" size="20" />
      ) : (
        <span class="material-icons">inventory</span>
      )}
      <span style={{ marginRight: '8px' }}>{rd.name}</span>
    </div>
  );
};
export { columns, generateData };
